import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { common, input } from "../../../../i18n";
import { Box, Button, IconButton } from "@mui/material";
import { CustomGridToolbarQuickFilter } from "../../../../components/datagrid/CustomGridToolbarQuickFilter";
import { GridToolbarContainer } from "@mui/x-data-grid";
import { GoalSettingContext } from "../../../../contexts/GoalSettingContext";
import alertService from "../../../../components/alert/alertService";
import { goalSettingService } from "../../../../service/goal-setting.service";

export const QuickSearchToolbar = () => {
  const { t } = useTranslation([common, input], {
    nsMode: "fallback",
  });
  const {
    setModalIsOpen,
    exitModal,
    selectionModel,
    setSelectionModel,
    rows,
    setGoals,
  } = GoalSettingContext();

  const MultipleDeleteGoals = async () => {
    const selectedGoals = rows.filter((s) => selectionModel.includes(s.id));
    const selectedNames = selectedGoals.map((s) => s.name).join(", ");

    const isConfirmed = await alertService.confirm(
      t("Delete-Goal"),
      <Trans
        t={t}
        i18nKey="Confirm-Delete-Multiple-Goals"
        values={{ names: selectedNames }}
        components={{
          span: <span style={{ color: "var(--red)" }} />,
        }}
      />,
      t("Delete"),
      "var(--red)",
    );

    if (isConfirmed) {
      setSelectionModel([]);
      let result;
      try {
        result = await goalSettingService.deleteGoals(
          selectedGoals.map((s) => s.goalRefId),
        );
      } catch {
        // error alert already shown by service
        return;
      }
      if (result) {
        setGoals(result.goals);
        alertService.mixin(t("Delete-Goal-Successful"));
      }
    }
  };

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      gap={"40px"}
      marginBottom={"40px"}
    >
      <Box
        display={"flex"}
        flexDirection={{ xs: "column-reverse", sm: "row" }}
        justifyContent={"space-between"}
        alignItems={"self-end"}
        gap={4}
      >
        <Box
          display={"flex"}
          flexDirection={{ xs: "column", sm: "row" }}
          gap={"12px"}
          flex={1}
          alignItems={"self-end"}
          width={{ xs: "100%", sm: "auto" }}
        >
          <CustomGridToolbarQuickFilter />

          {selectionModel.length > 0 && (
            <IconButton onClick={() => MultipleDeleteGoals()}>
              <img src="/img/trash.svg" alt="trash" />
            </IconButton>
          )}
        </Box>

        <GridToolbarContainer
          sx={{
            padding: 0,
            width: { xs: "100%", sm: "auto" },
          }}
        >
          <Button
            fullWidth
            variant="contained"
            color="secondary"
            startIcon={<img src="/img/add-circle.svg" alt="add-circle" />}
            onClick={() => {
              setModalIsOpen(true);
            }}
          >
            {t("Add-Goal")}
          </Button>
        </GridToolbarContainer>
      </Box>
    </Box>
  );
};
